import { render } from "./InnerLayout.vue?vue&type=template&id=bcb4785c&scoped=true"
import script from "./InnerLayout.vue?vue&type=script&lang=js"
export * from "./InnerLayout.vue?vue&type=script&lang=js"

import "./InnerLayout.vue?vue&type=style&index=0&id=bcb4785c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcb4785c"]])

export default __exports__